module.exports = __webpack_public_path__ + "static/media/patentesBorbaran.6c56877d.mp3";